export default __webpack_public_path__ + "static/media/successful-update.ac7a4887.svg";